
import { makeConstantFactory } from 'utils/constantsHelper'
const makeConstant = makeConstantFactory('googleAnalytics')

export const GET_GOOGLE_ANALYTICS_SETTINGS = makeConstant('GET_GOOGLE_ANALYTICS_SETTINGS')
export const GET_GOOGLE_ANALYTICS_SETTINGS_PENDING = makeConstant('GET_GOOGLE_ANALYTICS_SETTINGS_PENDING')
export const GET_GOOGLE_ANALYTICS_SETTINGS_SUCCESS = makeConstant('GET_GOOGLE_ANALYTICS_SETTINGS_SUCCESS')
export const GET_GOOGLE_ANALYTICS_SETTINGS_FAILED = makeConstant('GET_GOOGLE_ANALYTICS_SETTINGS_FAILED')

export const PATCH_GOOGLE_ANALYTICS = makeConstant('PATCH_GOOGLE_ANALYTICS')
export const PATCH_GOOGLE_ANALYTICS_PENDING = makeConstant('PATCH_GOOGLE_ANALYTICS_PENDING')
export const PATCH_GOOGLE_ANALYTICS_SUCCESS = makeConstant('PATCH_GOOGLE_ANALYTICS_SUCCESS')
export const PATCH_GOOGLE_ANALYTICS_FAILED = makeConstant('PATCH_GOOGLE_ANALYTICS_FAILED')


// WEBPACK FOOTER //
// ./src/scripts/app/modules/googleAnalytics/constants.js